import { DS_HEIGHT } from '@calm/evexia-design-tokens';
import { Box, SxProps, Theme } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import { PropsWithChildren } from 'react';

const styleContentWrapper: SxProps<Theme> = {
    display: 'grid',
    gridTemplateRows: 'auto 1fr auto',
    background: (theme: Theme) => theme.palette.gradient.backgroundPrimary,
};

// Full viewport height when the page has no global header; otherwise subtract
// the app toolbar so the gradient fills the space below it without overflowing.
const styleFullHeight = { minHeight: '100dvh' };
const styleHeaderOffsetHeight = {
    minHeight: `calc(100dvh - ${DS_HEIGHT.TOOLBAR}px)`,
};

interface AiJournalingPageContainerProps {
    sx?: SxProps<Theme>;
    /**
     * Set when the page renders below the global app header/toolbar so the
     * layout height accounts for it instead of overflowing the viewport.
     */
    hasGlobalHeader?: boolean;
}

/**
 * Shared outer wrapper for AI journaling sub-pages
 * (e.g. /journal/review, /journal/entry).
 *
 * Provides the theme gradient background and a 3-row grid layout
 * (auto / 1fr / auto) for header, scrollable content, and footer.
 */
export function AiJournalingPageContainer({
    children,
    sx,
    hasGlobalHeader = false,
}: PropsWithChildren<AiJournalingPageContainerProps>) {
    return (
        <Box
            sx={sxAppend(
                styleContentWrapper,
                hasGlobalHeader ? styleHeaderOffsetHeight : styleFullHeight,
                sx
            )}
        >
            {children}
        </Box>
    );
}

export default AiJournalingPageContainer;
